"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function isChildSelected(option, includeSelf) {
    if (includeSelf === void 0) { includeSelf = false; }
    return ((includeSelf && option.selected) ||
        (option.subFilter &&
            option.subFilter.options.some(function (opt) { return isChildSelected(opt, true); })));
}
exports.isChildSelected = isChildSelected;
function isSomethingSelected(filter, excludeAll) {
    if (excludeAll === void 0) { excludeAll = true; }
    return filter.options.some(function (opt) { return !(excludeAll && opt.all) && isChildSelected(opt, true); });
}
exports.isSomethingSelected = isSomethingSelected;
/**
 * We often need to rename RQL search params to create the right querystring params.
 * This is a helper to traverse Filters and update all the paramName fields based on
 * a mapping function.
 */
function renameParams(filters, renameFn) {
    return filters.map(function (filter) { return renameParamsSingle(filter, renameFn); });
}
exports.renameParams = renameParams;
function renameParamsSingle(oldFilter, renameFn) {
    var options = oldFilter.options.map(function (oldOption) {
        var paramName = renameFn(oldOption.paramName);
        var subFilter = oldOption.subFilter &&
            renameParamsSingle(oldOption.subFilter, renameFn);
        return tslib_1.__assign(tslib_1.__assign({}, oldOption), { paramName: paramName, subFilter: subFilter });
    });
    return tslib_1.__assign(tslib_1.__assign({}, oldFilter), { options: options });
}
/**
 * Accepts a facetOption, which may have nested options, and returns an array of FacetOptions
 * from the root to the node that is selected. For normal (non-nested) FacetOptions,
 * this simply returns [option] if selected and [] otherwise.
 */
function selectedPath(filter) {
    function traverse(option, acc) {
        if (acc === void 0) { acc = []; }
        if (option.selected) {
            return tslib_1.__spreadArrays(acc, [option]);
        }
        var selectedBranch = option.subFilter &&
            option.subFilter.options.find(function (opt) { return isChildSelected(opt, true); });
        if (!selectedBranch) {
            return acc;
        }
        return traverse(selectedBranch, tslib_1.__spreadArrays(acc, [option]));
    }
    var selectedOpt = filter.options.find(function (opt) { return isChildSelected(opt, true); });
    return selectedOpt ? traverse(selectedOpt) : [];
}
exports.selectedPath = selectedPath;
//# sourceMappingURL=facet_utils.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/facet_utils.js
// module id = lw+a
// module chunks = 0 1 2 3 4 9 10 14 20